import { cn } from "../cn";

/* 1:1 with discordforge.org — PrivacyView.tsx Toggle:
 *   h-8 w-12 rounded-full border-2 border-transparent p-1
 *   on:  bg-[#ff5a00]
 *   off: bg-white/10
 *   knob: h-6 w-6 rounded-full bg-white shadow-[0_2px_8px_rgba(0,0,0,0.28)]
 *   on knob: translate-x-4
 *   focus: ring-2 ring-orange-400/60 */
export interface SwitchProps {
    on: boolean;
    onToggle: () => void;
    disabled?: boolean;
    className?: string;
    "aria-label"?: string;
}

export function Switch({ on, onToggle, disabled, className, "aria-label": ariaLabel }: SwitchProps) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={on}
            aria-label={ariaLabel}
            onClick={onToggle}
            disabled={disabled}
            className={cn(
                "relative inline-flex h-8 w-12 flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent p-1",
                "transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-400/60",
                "disabled:cursor-not-allowed disabled:opacity-50",
                on ? "bg-[#ff5a00]" : "bg-white/10",
                className
            )}
        >
            <span
                className={cn(
                    "pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-[0_2px_8px_rgba(0,0,0,0.28)] ring-0",
                    "transition-transform duration-200 ease-in-out",
                    on ? "translate-x-4" : "translate-x-0"
                )}
            />
        </button>
    );
}
